class WishlistButton extends HTMLElement {
  constructor() {
    super();
    this._handleClick = this.toggleWishlist.bind(this);
    this._handleUpdate = this.syncStatus.bind(this);
  }

  connectedCallback() {
    this.productHandle = this.dataset.productHandle;
    this.removeEventListener('click', this._handleClick);
    this.addEventListener('click', this._handleClick);

    window.removeEventListener('wishlist:updated', this._handleUpdate);
    window.addEventListener('wishlist:updated', this._handleUpdate);

    this.syncStatus();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._handleClick);
    window.removeEventListener('wishlist:updated', this._handleUpdate);
  }

  syncStatus() {
    if (!this.productHandle) {
      this.productHandle = this.dataset.productHandle;
    }
    const wishlist = this.getWishlist();
    if (this.productHandle && wishlist.includes(this.productHandle)) {
      this.classList.add('is-active');
    } else {
      this.classList.remove('is-active');
    }
  }

  getWishlist() {
    try {
      const data = localStorage.getItem('shopify-wishlist');
      return data ? JSON.parse(data) : [];
    } catch (e) {
      return [];
    }
  }

  toggleWishlist(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!this.productHandle) {
      this.productHandle = this.dataset.productHandle;
    }
    if (!this.productHandle) return;

    let wishlist = this.getWishlist();
    if (wishlist.includes(this.productHandle)) {
      wishlist = wishlist.filter((handle) => handle !== this.productHandle);
      this.classList.remove('is-active');
    } else {
      wishlist.push(this.productHandle);
      this.classList.add('is-active');
    }
    try {
      localStorage.setItem('shopify-wishlist', JSON.stringify(wishlist));
    } catch (err) {
      console.warn('Could not save wishlist to localStorage', err);
    }
    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { wishlist } }));
  }
}

if (!customElements.get('wishlist-button')) {
  customElements.define('wishlist-button', WishlistButton);
}

